export default {
  id: "signature",
  name: "Signature",
  settings: {}
};
